
export default function Divider(props) {

    return (
    <div style={{padding: '30px 0px'}} className='col-xs-12'>
      <div style={{backgroundImage :'linear-gradient( to right, #fff, #222222, #fff)', opacity: 0.15, height: '1px', width: '100%'}} />
    </div>
    )

}



// WEBPACK FOOTER //
// ./components/contentTypes/divider/greyGradient.js